<div class="flex flex-row items-center justify-between gap-2 thin:gap-1" [ngClass]="{
  '-mr-2 thin:-mr-3': !noNegativeMargin()
}">
  <homey-lottery-list-item
    [openInPopup]="openInPopup()"
    [apartment]="lottery()"
    [showNeighbourhoodAndBorough]="true"
    class="min-w-0"
  >
    @let application = lottery().application;
    @if (application) {
      <p>Application submitted</p>
    } @else {
      @if ((lottery() | estimatedEligibility)()) {
        <p>Eligible</p>
      } @else {
        <p>Ineligible</p>
      }
    }
  </homey-lottery-list-item>
  @if ((lottery() | estimatedEligibility)() && !lottery().application) {
    <homey-submit-button class="flex-shrink-0 block" submitButtonLabel="Apply" size="small"
                         [submitFunction]="submit"></homey-submit-button>
  }
</div>
